import React, { createContext, useContext } from "react";
import { View } from "react-native";
import { theme } from "../../theme";
import { createDefaultCellStyles, createGridStyles, generateGridCellStyles, } from "./FlexGrid.styles";
const FlexGridContext = createContext({});
export const FlexGrid = ({ children, wrap: flexWrap = "wrap", style: userStyles, direction: flexDirection = "row", cellSpacing: paddingHorizontal = "small", rowSpacing: paddingBottom = "small", ...props }) => {
    return (React.createElement(View, { style: [
            createGridStyles(paddingHorizontal, flexWrap, flexDirection),
            userStyles,
        ], ...props },
        React.createElement(FlexGridContext.Provider, { value: {
                paddingHorizontal: paddingHorizontal !== null ? theme.spacing[paddingHorizontal] : 0,
                paddingBottom: paddingBottom !== null ? theme.spacing[paddingBottom] * 2 : 0,
            } }, children)));
};
export const FlexGridCell = ({ style: userStyles, children, base, xsmall, small, medium, large, xlarge, xlarge2, xlarge3, xlarge4, ...props }) => {
    const { paddingHorizontal, paddingBottom } = useContext(FlexGridContext);
    const { styles, ids } = generateGridCellStyles({
        base,
        xsmall,
        small,
        medium,
        large,
        xlarge,
        xlarge2,
        xlarge3,
        xlarge4,
    });
    return (React.createElement(View, { style: [
            styles.cell,
            createDefaultCellStyles(paddingHorizontal, paddingBottom),
            userStyles,
        ], dataSet: { media: ids.cell }, ...props }, children));
};
FlexGrid.Cell = FlexGridCell;
//# sourceMappingURL=FlexGrid.js.map